import React, {Component} from "react";
import {request} from "../../../helper/APIUtils";
import { showAxiosError} from "../../../helper/helper";
import moment from "moment";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import Table from "../../../components/Table/Table";
import ReactLoading from "react-loading";
import axios from "axios";
import SquareButtonX from "../../../components/SquareButtonX";
import PriceListModal from "./PriceListModal";
import {defterUnitName,defterUnitNameShort} from "../../../helper/permission";
import {EntegratorConf} from "../../../constants";

class DistributorPurchaseModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            content: [],
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            selected: [],
            selection: [],
            loading:false,
            alert: null,
            isMobile : window.innerWidth > 991 ? false : true,
            priceListModal: false,
            numberOfCredit : null,
            numberOfSpace : null,
            numberOfSellCredit : null,
            numberOfSellSpace : null,
            loading2: false
        };

        this.modifyDate = this.modifyDate.bind(this);
        this.defineCreditAction = this.defineCreditAction.bind(this);
        this.editClicked = this.editClicked.bind(this);
        this.getTrClass = this.getTrClass.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.openPriceListModal = this.openPriceListModal.bind(this);
        this.closePriceModal = this.closePriceModal.bind(this);
        this.paymentStatus = this.paymentStatus.bind(this);
        this.totalCredit = this.totalCredit.bind(this);
    }

    componentDidMount() {
        this.totalCredit();
    }

    openPriceListModal(){
        this.setState({priceListModal: true});
    }

    closePriceModal(){
        this.setState({priceListModal: false});
    }

    fetchData(accessor, direction,page, size) {
        let self = this;
        if (typeof this._fetchToken !== typeof undefined) {
            this._fetchToken.cancel();
        }
        this._fetchToken = axios.CancelToken.source();
        let params = {
            url: '/customer/fetchDistributorPurchase?page=' + page + '&size=' + size,
            method: "get",
            cancelToken: this._fetchToken.token
        };

        self.setState({loading: true});
        request(params)
            .then(function (response) {
                self.totalCredit(response.data);
                console.log(response.data.content)
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                });
            }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    totalCredit(){
        let self = this;
        let params = {
            url: '/customer/getActivityCredit',
            method: "get"
        };
         self.setState({loading2: true});
        request(params)
            .then(function (response) {
                console.log(response.data)
                self.setState({
                    numberOfCredit: response.data.adetCount,
                    numberOfSpace : response.data.alanCount,
                    numberOfSellCredit: response.data.sellAdet,
                    numberOfSellSpace : response.data.sellAlan,
                    loading2: false,
                });
            }).catch(function (error) {
             self.setState({loading2: false});
            showAxiosError(error);
        });
    }

    editClicked(row) {
        this.setState({creditChangeModal: true, selected: row});
    }

    defineCreditUnit(data) {
        console.log("data2",data);
        switch (data.unit) {
            case 1:
                return ['Adet', 'Kontör Adedi'];
            case 2:
                return [defterUnitNameShort(EntegratorConf.identifier), defterUnitName(EntegratorConf.identifier)];
            case  3:
                return ['E-Arşiv Kasa', 'E-Arşiv Kasa Adedi'];
        }
    }

    paymentStatus(data) {
        switch (data.paymentStatus) {
            case 1:
                return "Ödeme Bekleniyor";
            case 2:
                return "Ödeme Başırılı";
            case  3:
                return "Ödeme Başarısız";
        }
    }

    defineCreditAction(data) {
        switch (data.creditAction) {
            case 0:
                return 'Sıfır Başlangıç';
            case 1:
                return 'Satın Alma';
            case  2:
                return 'Devir (Giriş)';
            case  3:
                return 'Hediye';
            case  4:
                return 'Devir (Çıkış)';
            case  5:
                return 'Transfer';
            case  6:
                return 'Kredi Havuzuna Katılma';
            case  7:
                return 'Kredi Havuzundan Ayrılma';
        }
    }

    modifyDate(date) {
        return moment(date).format('DD-MM-YYYY');
    }

    getTrClass(row) {
        let dToMsCoef = (60*60*24*1000);
        let tolerateDay = this.state.tolerateDay;
        let toleranceMs = tolerateDay * dToMsCoef;

        let expirationDate = moment(row.expireDate).valueOf();
        let now = moment().valueOf();

        let msToExpiration = expirationDate - now;

        if (msToExpiration < 0) {
            return 'expired-credit-row';
        } else if (msToExpiration > 0 && msToExpiration < toleranceMs) {
            return "expiring-credit-row";
        } else {
            return ""
        }
    }

    toggleCheckboxChange(e, row, id) {
        let self = this;
        let selection = self.state.selection;
        if(selection.length > 0){
            selection.pop();
            selection.push(row[id]);
        }else{
            selection.push(row[id]);
        }
        self.setState({
            selection: selection
        });
    }

    isSelected(id) {
        return (this.state.selection.indexOf(id) !== -1);
    }


    render() {
        const {content, isMobile} = this.state;
        let columns = [
            {
                Header: "Birim",
                title: "Birim",
                accessor: "unit",
                sortable: false,
                Cell: row => (
                    <label>{this.defineCreditUnit(row)[1]}</label>
                )
            },
            {
                Header: "Alınan",
                title: "Alınan",
                accessor: "purchasequantity",
                sortable: false,
                Cell: row => (
                    <label>{row.purchaseQuantity}</label>
                )
            },
            {
                Header: "Kullanılan",
                title: "Kullanılan",
                accessor: "sellQuantity",
                sortable: false,
                Cell: row => (
                    <label>{this.getTrClass(row) === 'expired-credit-row' ?  row.sellQuantity :""}</label>
                )
            },
            {
                Header: "Yanan",
                title: "Yanan",
                accessor: "consideredCount",
                sortable: false,
                Cell: row => (
                    <label>{this.getTrClass(row) === 'expired-credit-row' ? (row.purchaseQuantity - row.sellQuantity) : ""}</label>
                )
            },
            {
                Header: "Fiyat",
                title: "Fiyat",
                accessor: "price",
                sortable: false,
                Cell: row => (
                    <label>{row.price}</label>
                )
            },
            {
                Header: "Başlangıç",
                title: "Başlangıç",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <label>{this.modifyDate(row.startDate)}</label>
                )
            },
            {
                Header: "Bitiş",
                title: "Bitiş",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <label>{this.modifyDate(row.expireDate)}</label>
                )
            },
            {
                Header: "Ödeme Durumu",
                title: "Ödeme Durumu",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <label>{this.paymentStatus(row)}</label>
                )
            },
            {
                Header: "Açıklama",
                title: "Açıklama",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <label>{row.paymentExplanation}</label>
                )
            }
        ];
        return (

            <div>
                <Modal isOpen={this.props.isOpen} size='lg'>
                    <ModalHeader toggle={()=>this.props.toggle()}>Fiyat Listesi</ModalHeader>
                    <ModalBody  style={{paddingTop: '4px'}} >
                        <div style={{paddingLeft: '15px'}} >
                            <SquareButtonX position="leftSide" onClick={this.openPriceListModal} img="plus_sign.png"
                                           label="Kontör Yükle"/>
                        </div>
                        <div className="col-sm-12 row" style={{right: '-15px'}}>
                            <Table columns={columns}
                                   content={content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   size={this.state.size}
                                   loading={this.state.loading}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetchData}
                                   getTrClass={this.getTrClass}
                            />
                        </div>
                        <Row style={{margin: '0'}}>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Aktif Alınan Kontör={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.numberOfCredit }
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Aktif Alınan {defterUnitName(EntegratorConf.identifier)}={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.numberOfSpace }
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Toplam Satılan Kontör={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.numberOfSellCredit }
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Toplam Satılan {defterUnitName(EntegratorConf.identifier)}={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : this.state.numberOfSellSpace }
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Toplam Satılandan Kalan Kontör={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> :  (this.state.numberOfCredit - this.state.numberOfSellCredit) }
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Toplam Satılandan Kalan {defterUnitName(EntegratorConf.identifier)}={this.state.loading2===true ? <ReactLoading type="spinningBubbles" style={{width:"10px", height: "10px", margin: "20px auto 0 auto", fill: "#888"}}/> : (this.state.numberOfSpace - this.state.numberOfSellSpace) }
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter></ModalFooter>
                </Modal>
                {this.state.priceListModal &&
                    <PriceListModal
                        isOpen={this.state.priceListModal}
                        toggle={this.closePriceModal}
                        paytrDomain={this.props.currentUser.paytrDomain}
                    />

                }

            </div>
        )
    }

}

export default DistributorPurchaseModal;